// ----------------------------------------------------------------------------- //
//  Decode encoded links
// ----------------------------------------------------------------------------- //
export default function decodeEncodedLinks() {

	const encodedElement = document.querySelectorAll("[data-encoded]");

	encodedElement.forEach(function (e) {
		const encodedString = e.getAttribute("data-encoded");
		const decodedString = atob(encodedString);

		e.setAttribute("href", decodedString);
		e.textContent = decodedString.replace(/http:\/\/|https:\/\/|ftp:\/\/|tel:|mailto:/g, '');
	});
};

// Usage example:
// <a href="javascript:void(0)" class="link" data-encoded="<?php echo base64_encode( 'mailto:contact@test.com' ); ?>">
//     <?php _e( 'Please enable JavaScript in your browser.', 'ockham-blocks' ); ?>
// </a>
